export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11483.229e0eb8.jpg";